/**
 * Created by Victor Rojo on 31/8/17.
 */
import {Component, OnInit, OnDestroy, Renderer2, AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap, NavigationEnd }                   from '@angular/router';
import {MediaChange, MediaObserver} from '@angular/flex-layout';

import { NotificationsService }   from 'angular2-notifications';
import { Subject }            from 'rxjs';
import {debounceTime, filter, map} from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';
import { interval ,  Unsubscribable as AnonymousSubscription }             from "rxjs";

import { AuthService }                      from "../shared/auth/auth.service";
import { SectionService }                   from "./section/Section.service";
import {Section} from "./section/Section";
import {SectionMap} from "./section/Section";
import {Widget, WidgetTypes, StatusLevels} from "./widget/Widget";
import {IPlaceService} from "../iPlace/iPlace.service";
import {NotificationMessageService} from "./notificationMessage/NotificationMessage.service";
import {NotificationMessage} from "./notificationMessage/NotificationMessage";
import {IPlaceValuelistService} from "../iPlace/iPlace-valuelist.service";
import {StatusNotificationService} from "./statusNotification/StatusNotification.service";
import {IPlaceDataChangeService} from "./IPlaceDataChange.service";
import {WidgetStatus} from "./widget/Widget";
import {NotificationService} from "../notification/notification.service";
import {StatusNotificationMessage} from "./statusNotification/StatusNotificationMessage";
import {Globals} from "../globals";
import {EcomanagerService} from './ecomanager/Ecomanager.service';
import {SidebarGeneratorService} from '../shared/component/sidebar-item/SidebarGenerator.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {PreviousRouteService} from "../shared/auth/PreviousRoute.service";

@Component({
  selector: 'iplace-dashboard-main',
  templateUrl: './IPlaceDashboardMain.component.html',
  styleUrls: ['./IPlaceDashboardMain.component.css'],
  animations: [
    trigger(
      "inAnimation",
      [
        transition(
          ":enter",
          [
            style({  opacity: 0 }),
            animate("1.5s ease-out",
              style({ opacity: 1 }))
          ]
        ),
      ]
    )
  ]

})
export class IPlaceDashboardMainComponent implements OnInit, OnDestroy, AfterViewInit{

  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  userName: string;
  WidgetTypes: any;

  activeMenu:string;
  statusNotificationMessages:NotificationMessage[] = [];
  private markForDeleteTimeouts:any[] = [];
  showNotificationSidebar = false;
  notificationMessages:NotificationMessage[] = [];
  notificationMessageIds:string[] = [];
  notificationMessageOffset = 0;
  notificationMessagePageSize = 20;
  private statusLevelOkId: number;
  private subscriptions: any[] = [];
  private StatusLevels:any;
  isLoadingNotifications = false;
  customization="";
  iPlaceListTitle = "iPlace";
  private interval: AnonymousSubscription;
  private reloadNotificationsInterval: AnonymousSubscription;
  private reloadNotifications:boolean = false;

  currentSectionId: string;
  iPlaceList:any[];
  iPlaceFilteredList:any[];
  searchInput = "";
  searchText= '';
  private searchTerms = new Subject<string>();
  showiPlaceFilter = false;
  sectionsMap:any = {};
  iPlaceMenus:any = {};
  isSidebarExpanded = true;
  activeMediaQuery: string;
  tenant = "smartpadel";
  sidebarItems;
  isLoading: boolean = true;

  constructor(
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sectionService: SectionService,
    private iPlaceService: IPlaceService,
    private notificationService: NotificationService,
    private notificationsService: NotificationsService,
    private notificationMessageService: NotificationMessageService,
    private statusNotificationService:StatusNotificationService,
    private iPlaceDataChangeService: IPlaceDataChangeService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private renderer: Renderer2,
    private mediaObserver: MediaObserver,
    private ecomanagerService: EcomanagerService,
    private sidebarService: SidebarGeneratorService,
    private globals: Globals,
    private previousRouteService: PreviousRouteService
  ) {
    this.WidgetTypes = WidgetTypes;
    this.StatusLevels = StatusLevels;

    this.ecomanagerService.getCredentials();

    this.sidebarService.getSidebarContentVertical(this.authService.getVertical())
      .then(list => {
        this.isLoading = false;
        this.sidebarItems = list;
        let previousUrl = this.previousRouteService.getPreviousUrl();

        if ( previousUrl == "/" || previousUrl == "/login" || this.router.url == "/cloud") {
          if ( this.sidebarItems.length ) {
            this.router.navigate(["cloud/" + this.sidebarItems[0].id ], {replaceUrl:true});
            this.activeMenu = this.sidebarItems[0].id;
          }
        }
      });

    this.iPlaceDataChangeService.startSSE(null);
    this.iPlaceValuelistService.clear();
    this.iPlaceService.get().then(list => {
      this.iPlaceList = list.sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.showiPlaceFilter = list.length > 5;
      this.filterIPlaceList();
      if ( list.length > 10 ) {
        list.forEach((iPlace:any) =>{
          this.iPlaceValuelistService.addValue(iPlace);
        });
        this.sectionService.getAll().then( response => {
          Object.keys(response).forEach( iplaceId => {
            this.sectionsMap[iplaceId] = this.getSectionTree(response[iplaceId]);
          })
        });
      } else {
        list.forEach((iPlace:any) =>{
          this.iPlaceValuelistService.addValue(iPlace);
          this.sectionService.get(iPlace.idiPlace).then( response => {
            this.sectionsMap[iPlace.idiPlace] = this.getSectionTree(response);
          });
        });
      }
    });
    this.reloadActiveStatusNotifications();
    this.statusLevelOkId = StatusLevels.OK;

    this.subscriptions.push(this.iPlaceDataChangeService.widgetStatusChange$.subscribe( (widgetStatus:WidgetStatus) => {
      this.reloadNotifications = true;
    }));

    this.subscriptions.push(this.iPlaceDataChangeService.statusNotificationChange$.subscribe( (statusNotification:StatusNotificationMessage) => {
      this.reloadNotifications = true;
    }));

    this.subscriptions.push(this.iPlaceDataChangeService.notificationChange$.subscribe( (notification:NotificationMessage) => {
      if ( notification.insertedDate && notification.insertedDate != notification.receivedDate) {

      } else {
        let toast;
        let options = {
          pauseOnHover: true,
          icons: {
            success: this.notificationsService.icons.info,
            warn: this.notificationsService.icons.warn,
            error: this.notificationsService.icons.error
          }
        };
        if ( notification.idNotificationLevel == 1 ) {
          toast = this.notificationsService.success( notification.iPlaceName, notification.name, options);
        } else if ( notification.idNotificationLevel == 2) {
          toast = this.notificationsService.warn( notification.iPlaceName, notification.name, options);
        } else if ( notification.idNotificationLevel == 3 || notification.idNotificationLevel == 4 ) {
          toast = this.notificationsService.error( notification.iPlaceName, notification.name, options);
        }
        if ( toast ) {
          let cloudDashboard = this.authService.getCloudDahsboard();
          toast.click.subscribe((event:any) => {
            if ( cloudDashboard ) {
              this.router.navigate(['cloud/notifications']);
            } else {
              this.router.navigate(['notifications']);
            }
          });
        }
      }

    }));

    this.setTenant();

    this.updateActiveMenu();

    this.notificationService.stopPolling();

    this.reloadNotificationsInterval = interval(3000)
      .subscribe(() => {
        if ( this.reloadNotifications ) {
          this.reloadActiveStatusNotifications();
          this.reloadNotificationList();
          this.reloadNotifications = false;
        }
      });

    this.interval = interval(60000)
      .subscribe(() => {
        this.iPlaceService.get().then(list => {
          let news = list.filter((iplace:any) => !this.iPlaceList.some(i => i.idiPlace == iplace.idiPlace));
          let iPlaceMap = this.iPlaceList.reduce((result,item) => {
            result[item.idiPlace] = item;
            return result;
          }, {});
          this.iPlaceList = list.sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName))
            .map(iplace => {
              if ( iPlaceMap[iplace.idiPlace] ) {
                Object.keys(iplace).forEach(function (field) {
                  iPlaceMap[iplace.idiPlace][field] = iplace[field];
                });
                return iPlaceMap[iplace.idiPlace];
              } else {
                return iplace;
              }
            });
          this.showiPlaceFilter = list.length > 5;
          this.filterIPlaceList();
          news.forEach((iPlace:any) =>{
            this.iPlaceValuelistService.addValue(iPlace);
            this.sectionService.get(iPlace.idiPlace).then( response => {
              this.sectionsMap[iPlace.idiPlace] = this.getSectionTree(response);
            });
          })
        });
      });


    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        this.searchText = result.toUpperCase();
        this.filterIPlaceList();
      });

  }

  private setTenant(){
    let customization = this.authService.getVertical();
    if ( customization ) {
      customization.split(" ")
        .forEach(klass => {
          if ( klass == "galp" || klass == "ask" || klass == "ecomanager" || klass == "hiotera" || klass == "nacexa"
              || klass == "geo4radon" || klass == "ecuador" || klass == "q8" || klass == "demoipetrol" || klass == "freeenergia"
              || klass == "kontrolwat" || klass == "respira" || klass == "iotino" || klass == "depourense" || klass == "h2h"
              || klass == "hacsuite" || klass == "smartpadel") {
            this.tenant = klass;
          }
        });
    }
    if (this.tenant == ""){
      this.tenant = 'smartpadel';
    }
    this.globals.tenant = this.tenant;
  }

  private updateActiveMenu() {
    let url = this.router.url;
    let pattern = new RegExp("/cloud/iplace/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/section/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}");

    if ( url == "/cloud/issues") {
      this.activeMenu = "issues";
    }
    else if ( url == "/cloud/notifications") {
      this.activeMenu = "notifications";
    }
    else if ( url == "/cloud/tank-deliveries") {
      this.activeMenu = "tank-deliveries";
    }
    else if ( url.startsWith("/cloud/iplaces") ) {
      this.activeMenu = "iplaces";
    }
    else if ( url == "/cloud/fuel-transaction") {
      this.activeMenu = "fuel-transaction";
    }
    else if ( url == "/cloud/settlement-report") {
      this.activeMenu = "settlement-report";
    }
    else if ( url == "/cloud/statistics") {
      this.activeMenu = "statistics";
    }
    else if ( url == "/cloud/surveillance") {
      this.activeMenu = "surveillance";
    }
    else if ( url == "/cloud/ranking") {
      this.activeMenu = "ranking";
    }
    else if ( url == "/cloud/recordings") {
      this.activeMenu = "recordings";
    }
    else if ( url == "/cloud/sales") {
      this.activeMenu = "sales";
    }
    else if ( url == "/cloud/reconciliation") {
      this.activeMenu = "reconciliation";
    }
    else if ( url == "/cloud/start") {
      this.activeMenu = "start";
    }
    else if ( url == "/cloud/historic") {
      this.activeMenu = "historic";
    }
    else if ( url == "/cloud/journal") {
      this.activeMenu = "journal";
    }
    else if ( url == "/cloud/configuration") {
      this.activeMenu = "configuration";
    }
    else if ( url == "/cloud/charts") {
      this.activeMenu = "charts";
    }
    else if ( url == "/cloud/ecopricing") {
      this.activeMenu = "ecopricing";
    }
    else if ( url == "/cloud/ecosensor") {
      this.activeMenu = "ecosensor";
    }
    else if ( url == "/cloud/ecompliance") {
      this.activeMenu = "ecompliance";
    }
    else if ( url == "/cloud/cei") {
      this.activeMenu = "cei";
    }
    else if ( url == "/cloud/tank-levels") {
      this.activeMenu = "tank-levels";
    }
    else if(url == "/cloud/tank-historic") {
      this.activeMenu = "tank-historic";
    }
    else if(url == "/cloud/tank-books") {
      this.activeMenu = "tank-books";
    }
    else if(url == "/cloud/levels-graph") {
      this.activeMenu = "levels-graph";
    }
    else if(url == "/cloud/manual-sales") {
      this.activeMenu = "manual-sales";
    }
    else if ( pattern.test(url)) {
      this.activeMenu = url.substr(14,36);
      this.currentSectionId = url.substr(59,36);
    }
    if ( !url.startsWith("/cloud/iplaces") ) {
      this.currentSectionId = null;
    }
  }

  ngOnInit():void {
    this.userName = this.authService.getUserName();
    this.customization = this.authService.getVertical();
    let tenant = this.globals.tenant;
    if ( this.customization ) {
      let favicon = "";
      this.customization.split(" ")
        .filter(klass => !!klass)
        .forEach(klass => {
          this.renderer.addClass(document.body, klass);
          if ( klass == "ipetrol") {
            this.iPlaceListTitle = "iPetrol";
            document.querySelector("title").textContent = "iPetrol Cloud";
            favicon = "assets/images/favicon_ipetrol.png";
          }
        });
      if ( tenant == "ask" ) {
        favicon = "assets/images/favicon_petrotec.ico";
      } else if ( tenant == "ecuador" ) {
        favicon = "assets/images/demo_ecuador/favicon_ecuador.png";
        document.querySelector("title").textContent = "Petrol Discount Control";
      } else if ( tenant == "ecomanager" ) {
        favicon = "assets/images/favicon_altereco.png";
        this.iPlaceListTitle = "Ecomótica";
      } else if ( tenant == "hiotera" ) {
        favicon = "assets/images/demo_hiotera/favicon-Hiotera.png";
      } else if ( tenant == "nacexa" ) {
        favicon = "assets/images/demo_nacexa/favicon-nacexa.png";
      } else if ( tenant == "geo4radon" ) {
        favicon = "assets/images/demo_geo4radon/favicon_geo4radon.png";
      }
      if ( favicon ) {
        document.querySelector("link[rel=icon]")['href'] = favicon;
      }
    }
  }

  ngAfterViewInit (): void {
    this.mediaObserver.asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      ).subscribe((change: MediaChange) => {
      this.activeMediaQuery = `${change.mqAlias}`;
      this.isSidebarExpanded = !(this.activeMediaQuery === "xs" || this.activeMediaQuery === "sm" || this.activeMediaQuery === "md");
    });
  }

  onToggleSidebarExpanded(){
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }


  reloadActiveStatusNotifications(){
    this.notificationMessageService.get(true)
      .then(list => {
        this.statusNotificationMessages = list;
      })
  }

  reloadNotificationList(){
    this.isLoadingNotifications = true;
    return this.notificationMessageService.get(false, 0, this.notificationMessagePageSize)
      .then(list => {
        this.isLoadingNotifications = false;
        this.notificationMessages = list;
        this.notificationMessageIds = list.map((notification:NotificationMessage) => notification.notificationId);
        this.notificationMessageOffset = list.length;
      })
  }

  navigateTo(route:string){
    this.activeMenu = route;
    this.currentSectionId = null;
    this.router.navigate(["cloud/" + route]);
  }

  toggleNotificationSidebar(){
    this.showNotificationSidebar = !this.showNotificationSidebar;
    if ( this.showNotificationSidebar ) {
      this.reloadNotificationList().then(() =>{
        this.notificationMessageService.ack(this.statusNotificationMessages.map(notification => notification.notificationId));
      }
      );
    }
  }

  logout(): void {
    this.authService.logout(false);
  }

  markForDelete(notificationMessage:any){
    notificationMessage.confirmDelete = true;
    this.markForDeleteTimeouts[notificationMessage.statusNotificationId] = setTimeout(()=>{
      notificationMessage.confirmDelete = false;
    }, 30000);
  }

  onSolvedDescriptionKeyUp(statusNotification:any){
    clearTimeout(this.markForDeleteTimeouts[statusNotification.statusNotificationId]);
    this.markForDeleteTimeouts[statusNotification.statusNotificationId] = setTimeout(()=>{
      statusNotification.confirmDelete = false;
    }, 30000);
  }

  solveStatusNotification(notificationMessage:any) {
    clearTimeout(this.markForDeleteTimeouts[notificationMessage.statusNotificationId]);
    notificationMessage.solving = true;
    this.statusNotificationService.solveStatusNotification(notificationMessage.notificationId, notificationMessage.solvedDescription)
      .then(response => {
        notificationMessage.solving = false;
        this.reloadActiveStatusNotifications();
        this.reloadNotificationList();
      });
  }

  onNotificationScrollDown(){
    let page = Math.floor(this.notificationMessages.length / this.notificationMessagePageSize);
    this.isLoadingNotifications = true;
    this.notificationMessageService.get(false, page, this.notificationMessagePageSize)
      .then(list => {
        this.isLoadingNotifications = false;
        list.forEach((notification:NotificationMessage) => {
          if ( this.notificationMessageIds.indexOf(notification.notificationId) == -1 ) {
            this.notificationMessages.push(notification);
            this.notificationMessageOffset++;
          }
        });
        let notificationIds = list
          .filter((notification:NotificationMessage) => !notification.isRead)
          .map((notification:NotificationMessage) => notification.notificationId);
        if ( notificationIds && notificationIds.length ) {
          this.notificationMessageService.ack(notificationIds);
        }
      });
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  clearFilter(){
    this.searchText = "";
    this.searchInput = "";
    this.filterIPlaceList();
  }

  private updateIPlaceList(list:any[]){
    this.iPlaceList = list;
    list.forEach(iPlace =>{
      if ( !this.iPlaceMenus[iPlace.idiPlace] ) {
        this.iPlaceMenus[iPlace.idiPlace] = true;
      }
      this.sectionService.get(iPlace.idiPlace).then( response => {
        this.sectionsMap[iPlace.idiPlace] = this.getSectionTree(response);
      });
    })
  }

  private filterIPlaceList(){
    if ( this.searchText ) {
      this.iPlaceFilteredList = this.iPlaceList.filter((iplace:any) => iplace.iPlaceName.toUpperCase().indexOf(this.searchText) >= 0);
    } else {
      this.iPlaceFilteredList = this.iPlaceList;
    }
  }


  private getSectionTree(sections:Section[]) {
    let sectionsMap = sections.reduce(function(map, section) {
      map[section.sectionId] = section;
      section['children'] = [];
      section['value'] = section.name;
      return map;
    }, {});

    sections.forEach(section => {
      if ( section.parentSectionId ) {
        let parent = sectionsMap[section.parentSectionId];
        if ( parent ) {
          parent.children.push(section);
        }
      }
    });
    sections.forEach((section:any) => {
      section.children = section.children.sort( (a:any,b:any) => a.name.localeCompare(b.name))
    });
    let homeSection = sections[0];
    return homeSection;
  }

  selectSection(e: any, iPlaceId:string): void {
    let section = e;
    if ( section == null ) {
      this.currentSectionId = null;
      this.activeMenu = iPlaceId;
      this.router.navigate(["cloud/iplace", iPlaceId, "section", "null"]);
    } else {
      this.activeMenu = section.iPlaceId;
      if ( this.currentSectionId != section.sectionId) {
        this.currentSectionId = section.sectionId;
        this.router.navigate(["cloud/iplace", section.iPlaceId, "section", section.sectionId]);
      }
    }
  }

  toggleMenu(event:any, iPlaceId:string){
    event.stopPropagation();
    this.iPlaceMenus[iPlaceId] = !this.iPlaceMenus[iPlaceId];
  }

  loadHomeSection(iPlaceId:string){
    let section = this.sectionsMap[iPlaceId];
    this.selectSection(section, iPlaceId);
  }

  public ngOnDestroy(): void {
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
    if ( this.reloadNotificationsInterval ) {
      this.reloadNotificationsInterval.unsubscribe()
    }
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.iPlaceDataChangeService.stopSSE();
    this.notificationService.resetLastNotificationTimestamp();
    if ( this.customization ) {
      this.customization.split(" ")
        .filter(klass => !!klass)
        .forEach(klass => this.renderer.removeClass(document.body, klass));
    }
    this.ecomanagerService.clearCredentials();
  }
}
